
import { AloConfigBase, cleanAloConfigBase, getDefaultAloConfigBase } from './AloConfigBase'


export interface AloConfigPiscine extends AloConfigBase { 
    infosFermeture:string,
}

export const getDefaultAloConfigPiscine = ():AloConfigPiscine => {
    return {  
        ...getDefaultAloConfigBase(),
        infosFermeture:""
    }
}

export const cleanAloConfigActivite = (config:AloConfigPiscine) => {
    cleanAloConfigBase(config)    
    if(!config) return    
}